﻿import {
  Button,
  Checkbox,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { getInsurerOfferCategoryName } from 'BrokerTsLib/src/enums'
import type { ManualStornoContractItem } from '@/hooks/useWizard'

type Props = {
  contracts: ManualStornoContractItem[]
  isOpen: boolean
  onClose: () => void
  onConfirm: (selectedIds: number[]) => void
}

export const ActiveContractsModal = ({ contracts, isOpen, onClose, onConfirm }: Props) => {
  const [selected, setSelected] = useState<Set<number>>(() => new Set(contracts.map(c => c.insuranceId)))

  useEffect(() => {
    setSelected(new Set(contracts.map(c => c.insuranceId)))
  }, [contracts])

  const toggle = (id: number, checked: boolean) => {
    setSelected(prev => {
      const next = new Set(prev)
      checked ? next.add(id) : next.delete(id)
      return next
    })
  }

  const hasSelection = selected.size > 0

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Byly dohledány následující aktivní smlouvy</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack gap={4}>
            <Text fontSize="sm" color="gray.600">
              Zvolte smlouvy, které chcete po vytvoření nového skladového pojištění stornovat.
            </Text>
            <Divider />
            <VStack align="stretch" gap={2}>
              {contracts.map(c => {
                const name = getInsurerOfferCategoryName(c.category)
                return (
                  <Checkbox
                    key={c.insuranceId}
                    isChecked={selected.has(c.insuranceId)}
                    onChange={e => toggle(c.insuranceId, e.target.checked)}
                    spacing={3}
                  >
                    <Text as="span" fontWeight="medium">{c.contractNumber}</Text>
                    {name && <Text as="span" color="gray.500" ml={2}>({name})</Text>}
                  </Checkbox>
                )
              })}
            </VStack>
          </Stack>
        </ModalBody>
        <ModalFooter gap={3}>
          <Button variant="outline" onClick={onClose}>
            Zrušit
          </Button>
          <Button
            colorScheme={hasSelection ? 'red' : 'blue'}
            onClick={() => onConfirm(hasSelection ? [...selected] : [])}
          >
            {hasSelection ? 'Pokračovat se stornem' : 'Pokračovat bez stornování'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
